<template>
	<div class="page d-flex">
		<MenuComponent />
		<AppViewComponent	 />
	</div>
</template>

<script>

import MenuComponent from '@/components/user/layout/MenuComponent.vue';
import AppViewComponent from '@/components/user/viewComponent/app/AppViewComponent.vue';

export default{
	name: 'AppsLibraryView',
  components:{
    MenuComponent,
    AppViewComponent,
  }
}
</script>

